import { combineReducers } from "redux";
import ticketraises from "../features/admin/ticketraise/Slice";

const ticketraise = combineReducers({
  ticketraises: ticketraises,
});

export default ticketraise;
